// 页面注册
import { lazy } from '@ozo/lazy-loader';

const UserLogin = lazy(() => import('./UserLogin'));
const Monitor = lazy(() => import('./Monitor'));
const Workplace = lazy(() => import('./Workplace'));
const Settings = lazy(() => import('./Settings'));

export { UserLogin, Monitor, Workplace, Settings };
